import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface CategoryActionMenuProps {
  row: any;
  canEdit: boolean;
  canConfigure: boolean;
  openModal: any;
}

export const CategoryActionMenu = ({
  row,
  canEdit,
  canConfigure,
  openModal,
}: CategoryActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            fontFamily: "var(--bs-font-sans-serif) !important",
            "& *": {
              fontFamily: "var(--bs-font-sans-serif) !important",
            },
            "& .MuiMenuItem-root": {
              minHeight: "28px",
              padding: "4px 12px",
            },
            "& .MuiMenuItem-root .MuiListItemText-primary": {
              fontSize: "13px !important",
              fontWeight: "500 !important",
            },
          },
        }}
      >
        {canEdit && (
          <MenuItem
            onClick={() => {
              navigate(`/edit-category/${row.original.category_id}`);
              handleClose();
            }}
            // sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            navigate(`/category-view/${row.original.category_id}`, {
              state: row.original,
            });
            handleClose();
          }}
          //   sx={{ color: "error.main" }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View" />
        </MenuItem>

        {canConfigure && (
          <MenuItem
            onClick={() => {
              openModal(row.original.category_name, row.original.category_id, {
                web_per: row.original.web_per,
                system_per: row.original.system_per,
              });
              handleClose();
            }}
          >
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Configure" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
